import { eventActions } from '../actions/eventAction';

const initialState = {
  events: [],
  future_events: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case eventActions.SAVE_ALL_EVENTS:
      return { ...state, events: action.events };
    case eventActions.SAVE_FUTURE_EVENTS:
      return { ...state, future_events: action.events };
    default:
      return state;
  }
}
